
import { Component, Prop, Vue } from "vue-property-decorator";
import OutlinePicker from "../OutlinePicker.vue";
import { v4 as uuidv4 } from "uuid";
import { StripEditorModel } from "./StripModel";

@Component({
  components: {
    OutlinePicker,
  },
})
export default class StripDetailsEditor extends Vue {
  @Prop() value!: StripEditorModel;

  uuid = uuidv4();

  update(): void {
    this.$emit("input", this.value);
  }
}
